import {
   Button,
   Heading,
   Modal,
   Paragraph,
} from "@nn-design-system/react-component-library";
import React from "react";
import { Box } from "@mui/material";

type NoDocumentsWarningModalProps = {
   isModalOpen: boolean;
   onClose: () => void;
   onContinueWithoutDocuments: () => void;
};

const NoDocumentsWarningModal: React.FC<NoDocumentsWarningModalProps> = ({
   isModalOpen,
   onClose,
   onContinueWithoutDocuments,
}) => {
   return (
      <Modal
         variant="Elevated"
         isOpen={isModalOpen}
         onClose={onClose}
         height="auto"
         width="44rem"
         hasBackdrop
      >
         <Box sx={{ padding: "2rem" }}>
            <Heading variant="Large" mb="1rem" hasMargin={false}>
               Opravdu chcete pokračovat bez nahrání dokumentů?
            </Heading>
            <Paragraph mb="2rem" hasMargin={false}>
               Dovolujeme si vás upozornit, že bez doložení dokumentů se šetření pojistné události prodlouží.
            </Paragraph>
            <Box
               sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  gap: "1rem",
                  justifyContent: "flex-end",
               }}
            >
               <Button variant="PrimaryMedium" onClick={onClose}>
                  Přiložit dokumenty nyní
               </Button>
               <Button
                  variant="SecondaryMedium"
                  onClick={onContinueWithoutDocuments}
               >
                  Pokračovat bez dokumentů
               </Button>
            </Box>
         </Box>
      </Modal>
   );
};

export default NoDocumentsWarningModal;
